export class PracticeIcon {
    uuid: string;
    name: string;
    iconUrl: string;
}

export function practiceIconSorter(practiceIcon1:PracticeIcon, practiceIcon2:PracticeIcon):number {
    return practiceIcon1.name.localeCompare(practiceIcon2.name);
}
